import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { impactoDoEnvio } from '../api/fluxfin';
import { Painel } from './common';
import { brl, numero } from '../utils/formato';

/**
 * O que este envio deixou para fazer no Nasajon.
 *
 * Aparece quando a fila termina. Sem isto, a tela de envio acabava no
 * resultado da extração e a pessoa tinha que descobrir sozinha quais títulos
 * mexer — que é justamente o passo seguinte do trabalho dela.
 */
export default function ImpactoDoEnvio({
  idLote,
  idArquivo,
  idsArquivo,
  titulo = 'O que este envio deixou para lançar',
  frase = 'Este envio afeta',
}) {
  const [dados, setDados] = useState(null);
  // A lista vem nova a cada render do pai; sem serializar, o efeito rodaria
  // para sempre.
  const chaveIds = (idsArquivo || []).join(',');

  useEffect(() => {
    let vivo = true;
    impactoDoEnvio({
      id_lote: idLote,
      id_arquivo: idArquivo,
      ids_arquivo: chaveIds ? chaveIds.split(',') : undefined,
    })
      .then((r) => vivo && setDados(r.data))
      .catch(() => vivo && setDados(null));
    return () => {
      vivo = false;
    };
  }, [idLote, idArquivo, chaveIds]);

  if (!dados?.resumo?.qtd) return null;

  const { por_estado: estados, qtd, qtd_pendentes: pendentes } = dados.resumo;
  const novos = estados?.a_lancar || 0;
  const atualizar = estados?.a_atualizar || 0;
  let link = `/titulos?id_arquivo=${idArquivo}`;
  if (idLote) link = `/titulos?id_lote=${idLote}`;
  else if (chaveIds) {
    link = `/titulos?${chaveIds
      .split(',')
      .map((x) => `ids_arquivo=${encodeURIComponent(x)}`)
      .join('&')}`;
  }

  return (
    <div className="mb-3">
      <Painel titulo={titulo}>
        <div className="p-3 d-flex flex-wrap gap-3 align-items-center">
          <div style={{ flex: 1, minWidth: 280, fontSize: 14 }}>
            {frase} <strong>{numero(qtd)}</strong> título
            {qtd === 1 ? '' : 's'}
            {pendentes > 0 ? (
              <>
                : <strong>{numero(novos)}</strong> pela primeira vez e{' '}
                <strong>{numero(atualizar)}</strong> a atualizar, somando{' '}
                <strong>{brl(dados.resumo.valor_pendente)}</strong> em baixas.
              </>
            ) : (
              <> — todos já conferidos no Nasajon.</>
            )}
            {/* A distinção entre os dois verbos é o conteúdo desta frase: um
                título novo se lança, um que já existe se EDITA. Somar no
                segundo caso é baixa em duplicidade. */}
          </div>
          {pendentes > 0 && (
            <Link to={link} className="ff-btn ff-btn--primario">
              <i className="bi bi-receipt" aria-hidden="true" />
              Ver os títulos
            </Link>
          )}
        </div>
      </Painel>
    </div>
  );
}
